import { Form, Input, InputNumber, Switch } from 'antd'
import React from 'react'
import { t } from 'i18next'

export default function TeleconsultingCompanyForm ({ form, onFinish, tc, disabled }) {
  return (
    <Form
      id="teleconsultingCompanyForm"
      form={form}
      labelAlign='left'
      layout='vertical'
      onFinish={onFinish}
      disabled={disabled}
    >
      <Form.Item name="name" label={t('Admin.TeleconsultingCompanyForm.name')}
        rules={[{ required: true, message: t('rules.required') }]}>
        <Input />
      </Form.Item>
      <Form.Item name="url" label={t('Admin.TeleconsultingCompanyForm.url')}
        rules={[{ required: true, message: t('rules.required') }]}>
        <Input />
      </Form.Item>
      <Form.Item name="minimum_age" label={t('Admin.TeleconsultingCompanyForm.minimum_age')}>
        <InputNumber min={0} max={150} />
      </Form.Item>
      <Form.Item name="increased_slot_duration" label={t('Admin.TeleconsultingCompanyForm.increased_slot_duration')} >
        <Switch onChange={(value) => form.setFieldValue('increased_slot_duration', value)} defaultChecked={tc?.increased_slot_duration} />
      </Form.Item>
    </Form>
  )
}
